import React from "react";

import Loading from "components/Loading";
import PageContent from "components/PageContent";
import PageSecondaryNavigation, {
  PageNavLink,
} from "components/PageSecondaryNavigation";
import {
  useCurrentOrganization,
  useCurrentServerGroup,
} from "components/WithCurrentOrganization";
import { useRoutes } from "utils/routes";

import DatabaseTable from "./DatabaseTable";
import ServerTable from "./ServerTable";

type Props = {
  tab: "servers" | "databases";
};

const ServerGroupDashboard = ({ tab }: Props) => {
  const currentOrganization = useCurrentOrganization();
  const currentServerGroup = useCurrentServerGroup(true);
  const { serverGroupDatabases, serverGroupServers } = useRoutes();
  if (currentServerGroup == null || currentOrganization == null) {
    return <Loading error />;
  }
  const featureNav = (
    <PageSecondaryNavigation>
      <PageNavLink to={serverGroupServers(currentServerGroup.id)}>
        All Servers
      </PageNavLink>
      <PageNavLink to={serverGroupDatabases(currentServerGroup.id)}>
        All Databases
      </PageNavLink>
    </PageSecondaryNavigation>
  );
  return (
    <PageContent
      title={
        <span>
          Server Group <strong>{currentServerGroup.name}</strong>
        </span>
      }
      featureNav={featureNav}
      windowTitle={`Dashboard: ${currentServerGroup.name}`}
      pageCategory="servergroup"
      pageName="show"
      pageTab={tab}
    >
      {tab === "servers" && (
        <ServerTable
          organizationSlug={currentOrganization.slug}
          clusterId={currentServerGroup.clusterId}
        />
      )}
      {tab === "databases" && (
        <DatabaseTable
          organizationSlug={currentOrganization.slug}
          clusterId={currentServerGroup.clusterId}
        />
      )}
    </PageContent>
  );
};

export default ServerGroupDashboard;
